"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var randomIdentifier = void 0;

randomIdentifier = function randomIdentifier() {
  var i = void 0;
  var possible = void 0;
  var text = void 0;
  i = void 0;
  possible = void 0;
  text = void 0;
  text = "";
  possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  i = 0;
  while (i < 5) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
    i++;
  }
  return text;
};

exports.default = randomIdentifier;